import React from 'react';
import { IQuestionnaireItemDisplayComponent } from '../../../modules/unsw-fhir/Questionnaire';
import { Conditionals } from '../../Fields/Conditional';
import { generateSimpleEnableWhenPredicate } from '../../../modules/unsw-fhir/QuestionnaireResponse/helpers';
import {
  getPromptTexts,
  getSupportingLinkUris,
} from '../../../modules/unsw-fhir/Questionnaire/extensions';
import DisplayField from '../../Fields/DIsplayItem';
import { useModal } from '../../../modules/unsw-modals';
const QuestionnaireDisplayItem = (
  props: IQuestionnaireItemDisplayComponent,
) => {
  const { enableWhen, ...rest } = props;
  const prompts = getPromptTexts(props);
  const supportLinks = getSupportingLinkUris(props);
  const { openSupportingLinks } = useModal();
  return enableWhen ? (
    <Conditionals
      question={props.linkId}
      enableWhens={enableWhen.map(ew => ({
        when: ew.question,
        is: generateSimpleEnableWhenPredicate(ew),
      }))}>
      {({ enabled }) =>
        enabled ? (
          <DisplayField
            name={props.linkId}
            text={rest.text || ''}
            informationText={prompts}
            supportingLink={
              supportLinks.length !== 0
                ? () => openSupportingLinks(supportLinks)
                : undefined
            }
          />
        ) : null
      }
    </Conditionals>
  ) : (
    <DisplayField
      name={props.linkId}
      text={rest.text || ''}
      informationText={prompts}
      supportingLink={
        supportLinks.length !== 0
          ? () => openSupportingLinks(supportLinks)
          : undefined
      }
    />
  );
};

export default QuestionnaireDisplayItem;
